// extracted by mini-css-extract-plugin
export default {"container":"styles_container__QiqPm","loading":"styles_loading__EQ3-w"};